import { render, staticRenderFns } from "./NewFileRequestDialogIntro.vue?vue&type=template&id=9c46bee6&scoped=true"
import script from "./NewFileRequestDialogIntro.vue?vue&type=script&lang=ts"
export * from "./NewFileRequestDialogIntro.vue?vue&type=script&lang=ts"
import style0 from "./NewFileRequestDialogIntro.vue?vue&type=style&index=0&id=9c46bee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c46bee6",
  null
  
)

export default component.exports